// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Delete: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<rect x="9.12" y="7.65" width="1.4" height="12.34"/>
<rect x="13.48" y="7.65" width="1.4" height="12.34"/>
<path d="M19.98,2.95h-4.74v-2.9H8.76v2.9H4.02v1.4h0.75v19.6h14.46V4.35h0.75V2.95z M10.16,1.45h3.68v1.5h-3.68V1.45z M17.83,22.55
	H6.17V4.35h11.66V22.55z"/>
</svg>;
};

export default React.memo(Delete);
